import ViewChannelHeader from './ViewChannelHeader'

export default ViewChannelHeader
